import React, { useContext } from "react";
import { leftIcon, rightIcon } from "../assets";
import { useNavigate } from "react-router-dom";
import ContactContext from "../context/ContactContext";

const Pagenation = () => {
  const navigate = useNavigate();
  const { page, setPage, setUpdated } = useContext(ContactContext);

  const handlePrevPage = () => {
    if (page === 1) {
      return;
    }
    setPage((prevPage) => prevPage - 1);
    setUpdated((prevUpdated) => !prevUpdated);
    navigate(`/page/${page - 1}`);
  };

  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
    setUpdated((prevUpdated) => !prevUpdated);
    navigate(`/page/${page + 1}`);
  };
  return (
    <div className="pagination-wrapper">
      <img
        src={leftIcon}
        alt="prev-icon"
        className="left-icon-svg"
        onClick={handlePrevPage}
      />
      <img
        src={rightIcon}
        alt="next-icon"
        className="right-icon-svg"
        onClick={handleNextPage}
      />
    </div>
  );
};

export default Pagenation;
